import {BaseAppView, BaseAppViewOptions} from "../../_BaseAppViews";
import {AnalyticsCollection} from "../collections/Analytics";
import {ModuleCollection} from "../../../collections/Modules";
import {AnalyticsChannelCollection} from "../collections/AnalyticsChannels";
import {BaseModifyModalView, BaseModifyModalViewOptions} from "../../../views/modals/_BaseModifyModal";
import {AnalyticsGroupCollection} from "../collections/AnalyticsGroups";
import {AnalyticsTemplateCollection} from "../collections/AnalyticsTemplates";

// The top level views
export interface BaseAnalyticsAppViewOptions extends BaseAppViewOptions {
    analyticsCollection: AnalyticsCollection;
    analyticsGroupCollection: AnalyticsGroupCollection;
    analyticsChannelCollection: AnalyticsChannelCollection;
    moduleCollections: { [key: number]: ModuleCollection; };
    analyticsGroupId: number;   // The current analytics group
}
export class BaseAnalyticsAppView extends BaseAppView {
    options: BaseAnalyticsAppViewOptions;
    constructor(options: BaseAnalyticsAppViewOptions){
        super(options);
    }
}

// The root view etc.
export interface BaseAnalyticsAppSubViewOptions extends BaseAnalyticsAppViewOptions {
    analyticsTemplateCollection: AnalyticsTemplateCollection;
    category: string;           // "channels" or "templates"
    itemId: number;             // The currently selected channel/template
}

export class BaseAnalyticsAppSubView extends BaseAnalyticsAppView {
    options: BaseAnalyticsAppSubViewOptions;

    constructor(options: BaseAnalyticsAppSubViewOptions) {
        super(options);
    }
}

// Sidebar, Virtual Channel Tool, etc.
export interface BaseAnalyticsAppRootSubViewOptions extends BaseAnalyticsAppSubViewOptions {
    canModifyGroup: boolean;
    currentOrganizationId: number;
}

export class BaseAnalyticsAppRootSubView extends BaseAnalyticsAppSubView {
    options: BaseAnalyticsAppRootSubViewOptions;

    constructor(options: BaseAnalyticsAppRootSubViewOptions) {
        super(options);
    }
}

// Modals
export interface BaseAnalyticsModalViewOptions extends BaseAnalyticsAppSubViewOptions, BaseModifyModalViewOptions {
}
export class BaseAnalyticsModalView extends BaseModifyModalView {

    options: BaseAnalyticsModalViewOptions;

    constructor(options: BaseAnalyticsModalViewOptions){
        super(options);
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/analytics/views/_BaseAnalyticsAppViews.ts